export enum PlatformProjectName {
  Emerge9 = "emerge9",
  Bullpen = "bullpen",
}
